export default __webpack_public_path__ + "static/monetisation@2x-118b56f9e480e41dd4463f13bccf9ca8.png";